module.exports = __webpack_public_path__ + "static/img/55.226c45f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/55.gif
// module id = +SS/
// module chunks = 0